import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ActiveFilterChip = {
  id: string;
  isValueLoading?: boolean;
  label: string;
  rawValue?: string;
  value: string;
};

@Component({
  selector: 'active-filter-chips',
  standalone: false,
  styleUrls: ['./active-filter-chips.component.scss'],
  templateUrl: './active-filter-chips.component.html',
})
export class ActiveFilterChipsComponent {
  @Input() public chips: ActiveFilterChip[] = [];

  @Output() public removeChip = new EventEmitter<ActiveFilterChip>();

  public onRemoveClicked(chip: ActiveFilterChip): void {
    this.removeChip.emit(chip);
  }
}
